var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C8.90434 11 8.81465 10.9841 8.73094 10.9523C8.64723 10.9205 8.56951 10.8664 8.49776 10.7901L5.19731 7.27863C5.06577 7.13868 5 6.96056 5 6.74427C5 6.52799 5.06577 6.34987 5.19731 6.20992C5.32885 6.06997 5.49626 6 5.69955 6C5.90284 6 6.07025 6.06997 6.20179 6.20992L9 9.18702L11.7982 6.20992C11.9297 6.06997 12.0972 6 12.3004 6C12.5037 6 12.6712 6.06997 12.8027 6.20992C12.9342 6.34987 13 6.52799 13 6.74427C13 6.96056 12.9342 7.13868 12.8027 7.27863L9.50224 10.7901C9.43049 10.8664 9.35277 10.9205 9.26906 10.9523C9.18535 10.9841 9.09567 11 9 11Z",
    fill: "#627487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown18);
export default __webpack_public_path__ + "static/media/down_18.4788b18850c845bf545bcb8227782f94.svg";
export { ForwardRef as ReactComponent };